<div class="upload-group">
  <h2 mat-dialog-title>Upload Media File</h2>
  <mat-dialog-content>
    <div fxLayout="column" fxLayoutAlign="start center">
      <div
        class="uploadfilecontainer"
        [ngClass]="{ isRunning: running }"
        (click)="fileInput.click()"
        appDragDrop
        (onFileDropped)="uploadFile($event)">
        <input
          hidden
          type="file"
          accept="video/mp4"
          #fileInput
          [(ngModel)]="fileInputModel"
          [disabled]="running"
          (change)="uploadFile($event.target.files)" />
        <div class="drag-drop">
          <div class="centered">Drag & drop to upload file</div>
          <div class="centered sub">
            Max upload size: {{ filesizeLimitString }}
          </div>
        </div>
        <div class="loader-container" *ngIf="running">
          <mat-spinner diameter="50" class="margin-auto"></mat-spinner>
        </div>
      </div>
      <mat-error *ngIf="files === null && running">No file uploaded</mat-error>
      <div
        fxLayout="column"
        fxLayoutAlign="start center"
        class="width100"
        *ngIf="files">
        <div fxFlex="100" class="files-list" *ngFor="let item of files">
          <span> {{ item.file.name }} </span>
          <div fxLayout="row">
            <span>{{ item.filesizeString }}</span>
            <i
              class="material-icons delete-file"
              [ngClass]="{ running: running }"
              [disabled]="running"
              (click)="deleteAttachment(item)">
              delete_forever
            </i>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      mat-raised-button
      color="primary"
      (click)="btnUploadFile()"
      [disabled]="running || this.files === null || this.files.length < 1">
      Upload
    </button>
  </mat-dialog-actions>
</div>
